/* PDP redesign — hero prev/next arrows.
   Adds bordered arrow buttons over the gallery hero and navigates by
   triggering the existing thumbnail buttons, so it reuses the theme's
   media-gallery logic (active media swap, deferred video, a11y) without
   touching media-gallery.js. Idempotent + re-inits on section reload. */
(function () {
  var PREV_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
  var NEXT_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>';

  function thumbButtons(thumbs) {
    // Only VISIBLE thumbnails — the theme hides media that don't belong to the
    // current variant (variant galleries). Cycling hidden ones shows a blank hero.
    return Array.prototype.slice.call(thumbs.querySelectorAll('[data-target]'))
      .filter(function (li) {
        return li.offsetParent !== null && getComputedStyle(li).display !== 'none';
      })
      .map(function (li) { return li.querySelector('button'); })
      .filter(Boolean);
  }

  function initArrows(gallery) {
    if (!gallery || gallery.dataset.rsArrows) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbs) return;
    var buttons = thumbButtons(thumbs);
    if (buttons.length < 2) return; // single image → no arrows
    gallery.dataset.rsArrows = '1';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'rs-gnav rs-gprev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = PREV_SVG;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'rs-gnav rs-gnext';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = NEXT_SVG;

    viewer.appendChild(prev);
    viewer.appendChild(next);

    function activeIndex() {
      var items = thumbButtons(thumbs);
      var idx = items.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
      return idx < 0 ? 0 : idx;
    }
    function go(delta) {
      var items = thumbButtons(thumbs);
      if (!items.length) return;
      var n = (activeIndex() + delta + items.length) % items.length;
      items[n].click();
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
  }

  function initAll() {
    document.querySelectorAll('.rs-pdp media-gallery').forEach(initArrows);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
